const KNOWN_STATIC_METHODS = [
  'fetchRootData',
  'fetchOpenGraphInfo',
  'fetchPageDataSSR',
  'fetchPageData',
  'fetchStaticShellProps',
  'Shell',
  'shellProps',
  'ssr',
  'options',
  'LoadingComponent',
  'ErrorComponent',
]

const hoistHocStatic = (WrappedComponent, Component, staticProps) => {
  if (typeof staticProps === 'object') {
    Object.assign(WrappedComponent, staticProps)
  }

  KNOWN_STATIC_METHODS.forEach(name => {
    if (typeof Component[name] !== 'undefined') {
      WrappedComponent[name] = Component[name]
    }
  })
}

export default hoistHocStatic